import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RoleSelector from './RoleSelectorComponent';
import {
  getCurrentRole,
  getFormatedRoles,
  getDefaultCostCenters
} from '../selector';

import * as actions from '../../../../auth/actions';
import * as globalActions from '../../../../action/CommonActions';

const mapStateToProps = state => ({
  role: getCurrentRole(state),
  roles: getFormatedRoles(state),
  firstName: state.auth.firstName,
  lastName: state.auth.lastName,
  costCenters: getDefaultCostCenters(state)
});

const mapDispatchToProps = dispatch => ({
  changeCurrentRole: bindActionCreators(actions.changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    globalActions.setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(
    globalActions.setGlobalDynamicFilter,
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleSelector);



// WEBPACK FOOTER //
// ./src/components/common/Profile/RoleSelector/RoleSelectorContainer.js